import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';

import { AngularMaterialCommonModule } from '@app/shared/angular-material/angular-material-common.module';
import {
  FeatureEnum,
  SelectedPlanData
} from '@app/plan-manager/plan-manager.model';
import { PlanManagerService } from '@app/plan-manager/plan-manager.service';

import {
  CallbackEnum,
  menuGroupFeatures,
  MenuGroupsEnum,
  MenuItemTitleEnum
} from '../../navigation-components.model';
import { ExpansionPanelComponent } from '../expansion-panel/expansion-panel.component';
import { HeaderService } from '../header.service';

@Component({
  selector: 'app-header-navigation',
  templateUrl: './header-navigation.component.html',
  styleUrls: ['./header-navigation.component.scss'],
  standalone: true,
  imports: [CommonModule, AngularMaterialCommonModule, ExpansionPanelComponent]
})
export class HeaderNavigationComponent {
  @Input() isMenuOpen: boolean;
  callback = CallbackEnum;
  feature = FeatureEnum;
  menuItemTitleEnum = MenuItemTitleEnum;
  menuGroups = MenuGroupsEnum;
  selectedPlanData$: Observable<SelectedPlanData>;

  constructor(
    private headerService: HeaderService,
    private planManagerService: PlanManagerService
  ) {
    this.selectedPlanData$ = this.planManagerService.getSelectedPlanData;
  }

  public navigateTo(url: string): void {
    this.headerService.navigateTo(url);
  }

  public handleNavigationItemAction(
    feature: FeatureEnum,
    registration: string
  ) {
    this.headerService.featAction(feature, registration);
  }

  public mountMenuGroup(
    group: MenuGroupsEnum,
    featList: FeatureEnum[]
  ): FeatureEnum[] {
    return menuGroupFeatures[group].filter((feat: FeatureEnum) =>
      this.hasFeatOn(feat, featList)
    ) as FeatureEnum[];
  }

  public hasFeatOn(feature: FeatureEnum, featList: FeatureEnum[]): boolean {
    return this.planManagerService.hasFeatOn(feature, featList);
  }
}
